import AllLogin from "../../common/all-login";
import "../../../assets/scss/login.scss";
import { ApiRoutes } from "../../../core/dictionary/api-url";

export default function LoginHero() {
  const coachTeamMemberLoginConfig = {
      rightSectionHeading: "RESUSCITATION TRAINING THAT BUILDS CONFIDENCE.",
      rightSectionSubHeading: "Code Blue Readiness for Teams That Save Lives.",
      leftCardHeading: "Admin Login",
      apiEndpoint: ApiRoutes.LOGIN_ADMIN,
      loginType: "admin-login",
      nextNavigationPath: "/admin/dashboard",
    };
    return <AllLogin config={coachTeamMemberLoginConfig}></AllLogin>;
  }
